"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StandardViewState = /** @class */ (function () {
    function StandardViewState() {
        this.disabled = true;
        this.userID = '';
        this.isUserIDinValid = false;
        this.userIDErrorMessage = '';
        this.saveId = true;
        this.errorMessage = '';
        this.errormessagePasswordComponent = '';
        this.passwordValue = '';
        this.isPasswordinValid = false;
        this.passwordErrorMessage = '';
        this.capsWarning = false;
        this.isNumberFormat = false;
        this.errorMessageCounter = 0;
        this.processing = false;
    }
    return StandardViewState;
}());
exports.default = StandardViewState;
//# sourceMappingURL=StandardViewState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/panels/LoginWidget/StandardView/StandardViewState.js
// module id = 1492
// module chunks = 8